export default __webpack_public_path__ + "static/media/transfer-bank.d5762cea.png";